import { Text } from "rebass/styled-components";
import styled from "styled-components";

import { ReasonIcon } from "../ReasonIcon";
import { SUGGESTED_REASON_CONFIG } from "../../Views/Homepage/SuggestedItem/reasonConfig";

interface ISuggestionBadgeProps {
  reason: string;
  showTooltip?: boolean;
}

export const SuggestionBadge = ({
  reason,
  showTooltip = false,
}: ISuggestionBadgeProps) => {
  const reasonConfig = SUGGESTED_REASON_CONFIG[reason];

  if (!reasonConfig) return null;

  return (
    <ReasonBadge>
      <ReasonIcon reason={reason} showTooltip={showTooltip} />
      {reasonConfig.display}
    </ReasonBadge>
  );
};

const ReasonBadge = styled(Text)`
  align-items: center;
  backdrop-filter: blur(8px);
  background: ${({ theme }) => theme.colors.midnightAlpha50};
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: ${({ theme }) => theme.colors.ice};
  display: flex;
  font-size: 12px;
  font-weight: 500;
  justify-content: center;
  padding: 6px 8px;
`;
